// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Ai7-b","input":"styles_input__nBOHN"};